import React, { useState } from 'react';
import Select from "react-select";
import api from '../../../../config/axios';
import Swal from 'sweetalert2';
import DateTimePicker from '../../../../components/utils/datetimepicker';

import { autoCompleteProdutos } from "../../../../components/utils/autocompletes";
import { FaRegSave, FaTimes } from 'react-icons/fa';

const SaidaProdutoModal = ({ onClose, onSaidaRegistrada }) => {
    const { inputPesquisaProduto, produtosOptions, handleAutoCompleteProdutos, handleFocusProdutos } = autoCompleteProdutos();
    
    const [formData, setFormData] = useState({
        produto: '',
        data_hora: new Date(),
        observacao: '',
        quantidade: ''
    });

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            whiteSpace: "pre-line",
        }),
        option: (provided) => ({
            ...provided,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
        }),
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSelectChange = (name, value) => {
        setFormData((prevState) => ({
            ...prevState,
            [name]: value || "",
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const camposObrigatorios = [
            { campo: 'produto', label: 'Produto' },
            { campo: 'data_hora', label: 'Data e Hora' },
            { campo: 'observacao', label: 'Observações' },
            { campo: 'quantidade', label: 'Quanto Saiu' }
        ];

        const camposInvalidos = camposObrigatorios.filter(({ campo }) => {
            const valor = formData[campo];

            if (typeof valor === 'string') return !valor.trim();
            if (valor instanceof Date) return false;
            if (typeof valor === 'object' && valor !== null) return !valor.value;
            return !valor;
        });

        if (camposInvalidos.length > 0) {
            Swal.fire('Erro', `Os seguintes campos são obrigatórios: ${camposInvalidos.map(c => c.label).join(', ')}`, 'error');
            return;
        }

        if (parseInt(formData.quantidade) <= 0) {
            Swal.fire( 'Erro', 'A quantidade deve ser maior que zero.', 'error');
            return;
        }

        if (parseInt(formData.quantidade) > formData.produto.estoque_atual) {
            Swal.fire('Erro', `A quantidade não pode ser maior que o estoque atual (${formData.produto.estoque_atual} unidades).`, 'error');
            return;
        }

            const estoqueAposRetirada = formData.produto.estoque_atual - parseInt(formData.quantidade);
            if (estoqueAposRetirada < formData.produto.estoque_minimo) {
                Swal.fire('Erro', `Após a retirada, o estoque ficará com ${estoqueAposRetirada} unidades, que é menor que o estoque mínimo (${formData.produto.estoque_minimo} unidades).`, 'error');
                return;
            }

        const dataHoraFormatada = formData.data_hora instanceof Date
            ? formData.data_hora.toISOString().slice(0, 19).replace('T', ' ')
            : formData.data_hora;
        
        const data = {
            id_produto: formData.produto.value,
            quantidade: parseInt(formData.quantidade),
            observacao: formData.observacao,
            data_hora: dataHoraFormatada
        };

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            await api.post(`/produtos-movimentacao/saida`, data);
            
            onSaidaRegistrada();
            onClose();
            Swal.fire('Sucesso', 'Saída de produto registrada com sucesso!', 'success');
        }
        catch (error) {
            Swal.close();
            Swal.fire('Erro', `${error.response.data.message}`, 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Registrar Saída</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row mt-3">
                                <div className="col-lg-8 col-12">
                                    <label className="form-label fw-bold">Produto</label>
                                    <Select
                                        options={produtosOptions}
                                        styles={customStyles}
                                        onInputChange={(value) => {
                                            handleAutoCompleteProdutos(value);
                                        }}
                                        onFocus={handleFocusProdutos}
                                        onChange={(value) => handleSelectChange('produto', value)}
                                        placeholder="Digite o nome do produto"
                                        isClearable
                                        menuPlacement="auto"
                                        menuPosition="fixed"
                                        noOptionsMessage={() => "Sem opções"}
                                        value={formData.produto}
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Data e Hora</label>
                                    <DateTimePicker
                                        selected={formData.data_hora}
                                        onChange={(date) => setFormData(prev => ({ ...prev, data_hora: date }))}
                                    />
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Observações</label>
                                    <textarea
                                        name="observacao"
                                        rows="3"
                                        className="form-control"
                                        autoComplete="off"
                                        value={formData.observacao}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-lg-4 col-12">
                                    <label className="form-label fw-bold">Quanto Saiu</label>
                                    <div className="input-group">
                                        <input
                                            type="number"
                                            name="quantidade"
                                            className="form-control"
                                            autoComplete="off"
                                            value={formData.quantidade}
                                            onChange={handleChange}
                                            placeholder="0"
                                            min="1"
                                        />
                                        <span className="input-group-text">unidades</span>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SaidaProdutoModal; 